import { createContext } from 'react';

/**
 * The footer element of the enclosing `NoddiDialog` / `NoddiSheet`, where `NavioOverlayActions`
 * renders. `undefined` = not inside an overlay (render in place); `null` = inside one whose footer
 * has not mounted yet (render nothing for that one commit rather than flash in the body).
 */
const OverlayActionsSlot = createContext<HTMLElement | null | undefined>(undefined);

export { OverlayActionsSlot };
